import React from "react";
import {
  AMT_ATTACH_ID,
  PLAN_CARDS_ID,
  REVAMP_COMPONENT_MAPPER,
} from "./componentMapper";

export interface ComponentCard {
  id: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
}

interface ComponentRendererProps {
  components?: ComponentCard[];
  onLoginRequest?: () => void;
  onAmtToggle?: (enabled: boolean) => void;
  amtEnabled?: boolean;
  onCompareClick?: () => void;
  pageTracked?: boolean;
}

const ComponentRenderer: React.FC<ComponentRendererProps> = ({
  components,
  onLoginRequest,
  onAmtToggle,
  amtEnabled,
  onCompareClick,
  pageTracked,
}) => {
  if (!components) {
    return null;
  }

  return (
    <>
      {components.map((card, index) => {
        if (!card?.id) return null;
        const CardComponent = REVAMP_COMPONENT_MAPPER[card.id];
        if (!CardComponent) return null;

        const key = `${card.id}-${index}`;
        const isAmtAttach = card.id === AMT_ATTACH_ID;
        const isPlanCards = card.id === PLAN_CARDS_ID;

        if (card.data && typeof card.data === "object") {
          return (
            <CardComponent
              key={key}
              {...card.data}
              onLoginRequest={onLoginRequest}
              pageTracked={pageTracked}
              {...(isAmtAttach && {
                onToggle: onAmtToggle,
                enabled: amtEnabled,
              })}
              {...(isPlanCards && { onCompareClick })}
            />
          );
        }
        return (
          <CardComponent
            key={key}
            data={card.data}
            onLoginRequest={onLoginRequest}
            pageTracked={pageTracked}
            {...(isAmtAttach && { onToggle: onAmtToggle, enabled: amtEnabled })}
            {...(isPlanCards && { onCompareClick })}
          />
        );
      })}
    </>
  );
};

export default ComponentRenderer;
